<template>
  <div>
    <div class="tw:overflow-x-hidden">
      <AuthMenu isLanding @onRegisterClick="onAuthorize('login')" pageName="studio-plus" />
      <StudioPlusHero v-scroll-animate="{ duration: '2s', delay: '0.3s' }" @onLoginClick="onAuthorize('login')" />
      <StudioPlusBenefits v-scroll-animate="{ duration: '2s', delay: '0.3s' }" class="tw:bg-white" />
      <LandingPageProductsComparison
        v-scroll-animate="{ duration: '2s', delay: '0.3s' }"
        title="tbs_product_header"
        product="studio-plus"
        @onLoginClick="onAuthorize('login')"
      />
      <StudioPlusPromoBanner
        v-scroll-animate="{ duration: '2s', delay: '0.3s' }"
        class="tw:bg-white"
        @onLoginClick="onAuthorize('login')"
      />
      <ProductPageFaq v-scroll-animate="{ duration: '2s', delay: '0.3s' }" pageName="studio-plus" class="tw:bg-white" />
    </div>
    <ThePageFooter isLanding />
    <ChatWidget />
  </div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import appAnalytics from '@/utils/tracking'
import AuthMenu from '@/components/landingPage/AuthMenu.vue'
import StudioPlusHero from '@/components/productPage/studioPlus/StudioPlusHero.vue'
import StudioPlusBenefits from '@/components/productPage/studioPlus/StudioPlusBenefits.vue'
import ProductPageFaq from '@/components/productPage/ProductPageFaq.vue'
import ThePageFooter from '@/components/page/ThePageFooter.vue'
import LandingPageProductsComparison from '@/components/landingPage/LandingPageProductsComparison.vue'
import StudioPlusPromoBanner from '@/components/productPage/studioPlus/StudioPlusPromoBanner.vue'
import ChatWidget from '@/components/chatbot/ChatWidget.vue'

import { useSessionValues } from '@/composables/useSessionValues'
import type { AuthType, AuthData } from '@/types'

const store = useStore()
const route = useRoute()

const { language } = useSessionValues()

const authorize = (authData: AuthData): Promise<void> => store.dispatch('session/authorize', authData)
const onAuthorize = async (type: AuthType = 'login'): Promise<void> => {
  appAnalytics.track(appAnalytics.events.BUTTON_CLICKED, {
    button: type,
    property_id: null,
  })

  await authorize({
    type,
    locale: language.value,
    stateParams: {
      redirectFrom: route.query['redirectFrom'],
    },
  })
}
</script>

<style scoped>
.terms-body :deep(p) {
  margin-bottom: 16px;
}
.terms-body :deep(a) {
  color: #007bff;
}
.terms-body :deep(h3) {
  font-weight: bold;
  margin-bottom: 16px;
  font-size: 28px;
  line-height: 35px;
  margin-top: 32px;
}
.terms-body :deep(#exhibit-1) {
  padding-top: 64px;
}

.terms-body :deep(#exhibit-2) {
  padding-top: 64px;
}
</style>
